// // src/pages/PaymentSuccessful.jsx
// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useSearchParams } from "react-router-dom";
// import { format } from "date-fns";
// import { post } from "../lib/http.js";
// import { API } from "../config/api.js";
// import { CheckCircleIcon, XCircleIcon, ClockIcon } from "@heroicons/react/24/solid";

// function downloadBlob(blob, filenameFallback = "file.bin") {
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filenameFallback;
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
//   URL.revokeObjectURL(url);
// }

// function b64toBlob(b64, type) {
//   const bin = atob(b64);
//   const arr = new Uint8Array(bin.length);
//   for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
//   return new Blob([arr], { type });
// }

// export default function PaymentSuccessful() {
//   const { state } = useLocation();
//   const [search] = useSearchParams();
//   const ticketRef = useRef(null);

//   // read helper: state → query → default
//   const q = (k, d = "") => state?.[k] ?? search.get(k) ?? d;

//   // server verify state
//   const [verifying, setVerifying] = useState(true);
//   const [verifyOk, setVerifyOk] = useState(false);
//   const [verifyErr, setVerifyErr] = useState("");
//   const [server, setServer] = useState(null);
//   const [downloading, setDownloading] = useState(false);

//   // ---- POST to payout.PaymentSuccessful on mount ----
//   useEffect(() => {
//     const razorpay_payment_id = q("razorpay_payment_id");
//     const razorpay_payment_link_id = q("razorpay_payment_link_id");

//     if (!razorpay_payment_id || !razorpay_payment_link_id) {
//       setVerifying(false);
//       setVerifyOk(false);
//       setVerifyErr("Missing payment identifiers.");
//       return;
//     }

//     (async () => {
//       try {
//         setVerifying(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//         const res = await post(
//           API.payout.PaymentSuccessful,
//           { razorpay_payment_id, razorpay_payment_link_id },
//           {
//             headers: {
//               Authorization: token ? `Bearer ${token}` : undefined,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         setServer(res || null);
//         setVerifyOk(true);
//         setVerifyErr("");
//       } catch (err) {
//         console.error("PaymentSuccessful verify error:", err);
//         setVerifyOk(false);
//         setVerifyErr("Verification failed. Please contact support.");
//       } finally {
//         setVerifying(false);
//       }
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ---- Amount breakdown (GST-aware) ----

//   const gross = firstNum(server?.payment?.finalAmount, q("amount", "0")); // total paid (₹)
//   const gstPct = firstNum(server?.payment?.gstAmount, q("gst", "18"));        // default 18%
//   const platformFee = firstNum(server?.fee, q("fee", "0"));           // your fee (₹)

//   const baseExGST = Math.max(0, Math.round((server?.payment?.amount) / (1 + gstPct / 100)));
//   // Pure GST on base:
//   const gstAmount = Math.max(0, (gross - platformFee) - baseExGST);

//   // ---- UI data (prefer server fields) ----
//   const ui = {
//     customerName: server?.booking?.userId?.name ?? q("name", "Guest"),
//     qrCodeUrl: server?.tickets.qrCode,
//     orderAmount: server?.payment?.amount,                // GST-excl base
//     fee: server?.payment?.convenienceFee,
//     gst: gstPct,        // fee + GST
//     finalAmount: gross,                    // total paid

//     eventTitle: server?.booking?.eventId?.name ?? q("event", "Event"),
//     venue: server?.booking?.eventId?.venue?.name ?? q("venue", "Venue"),
//     startISO: server?.booking?.eventId?.date ?? q("start", ""),
//     endISO: server?.booking?.eventId?.date ?? q("end", ""),

//     bookingDateISO:
//       server?.bookedAt ??
//       server?.booking?.createdAt ??
//       q("date", new Date().toISOString()),
//     bookingId: server?.bookingId ?? server?.booking?.bookingCode ?? q("bookingId", "STMZ2025"),

//     attendeeName: server?.booking?.userId?.name ?? q("name", "Guest"),
//     attendeePhone: server?.booking?.userId?.mobile ?? q("phone", ""),
//   };

//   const day = format(new Date(ui.bookingDateISO), "dd");
//   const month = format(new Date(ui.bookingDateISO), "LLLL").toUpperCase();
//   const fullStamp = format(new Date(ui.bookingDateISO), "dd/MM/yyyy HH:mm:ss");

//   const whenRange =
//     ui.startISO && ui.endISO
//       ? `${format(new Date(ui.startISO), "MMM dd, yyyy")} - ${format(
//         new Date(ui.endISO),
//         "MMM dd, yyyy"
//       )}`
//       : ui.startISO
//         ? format(new Date(ui.startISO), "MMM dd, yyyy")
//         : "—";

//   const onPrint = () => window.print();

//   // ---- Direct PDF Download (no link needed) ----
//   const onDownload = async () => {
//     try {
//       console.log(server)
//       const token =
//         JSON.parse(localStorage.getItem("bb_user") || "{}")?.token ?? null;

//       const url = `http://20.41.122.214:5151/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(server?.booking?.bookingCode)}`

//       const resp = await fetch(url, {
//         method: "POST",
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       if (!resp.ok) {
//         const msg = await resp.text().catch(() => "");
//         throw new Error(`HTTP ${resp.status} ${msg}`);
//       }

//       const ct = (resp.headers.get("content-type") || "").toLowerCase();
//       let blob;

//       if (ct.includes("application/pdf")) {
//         blob = await resp.blob();
//       } else if (ct.includes("application/json")) {
//         const data = await resp.json().catch(() => ({}));
//         if (data?.pdfBase64) {
//           blob = b64toBlob(data.pdfBase64, "application/pdf");
//         } else if (data?.url) {
//           window.location.href = data.url;
//           return;
//         } else {
//           throw new Error("JSON received but no pdfBase64/url.");
//         }
//       } else {
//         // Try anyway
//         blob = await resp.blob();
//       }

//       // filename (optional)
//       const cd = resp.headers.get("content-disposition") || "";
//       const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
//       const suggested =
//         m && m[1] ? decodeURIComponent(m[1]) : undefined;

//       const safeEvent = (server?.booking?.eventId?.name || "ticket")
//         .replace(/\s+/g, "-")
//         .slice(0, 50);
//       const fallback = suggested || `${safeEvent}-${server?.booking?.bookingCode}.pdf`;

//       downloadBlob(blob, fallback);
//     } catch (err) {
//       console.error("PDF download error:", err);
//       alert(err?.message || "Could not download PDF. Please try again.");
//     }
//   };

//   // QR code URL (server preferred, fallback to ?qr=...)
//   const qrUrl = server?.tickets?.qrCode ?? q("qr", "");


//   return (
//     <div className="w-full px-4 md:px-6 py-8 print:py-0 flex justify-center">
//       {/* print CSS */}
//       <style>{`
//         @page { margin: 0; size: auto; }
//         @media print {
//           header, footer, nav, .site-header, .site-footer, .app-header, .app-footer {
//             display: none !important;
//           }
//           .print-wrap {
//             box-shadow: none !important;
//             border: 0 !important;
//             border-radius: 0 !important;
//           }
//           body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//         }
//       `}</style>

//       <div
//         ref={ticketRef}
//         className="print-wrap w-full max-w-5xl bg-white rounded-2xl shadow-md border relative print:shadow-none print:border-0 print:rounded-none"
//       >
//         {/* Header */}
//         <div className="px-6 md:px-8 pt-6">
//           <h1 className="text-2xl md:text-3xl font-extrabold text-[#4B1FA0]">
//             Booking Confirmed!
//           </h1>
//           <p className="mt-1 text-sm md:text-base text-[#4B1FA0]">
//             {ui.customerName}, your ticket is booked!
//           </p>

//           {/* Notice bar */}


//           <div
//             className={`mt-5 flex items-center justify-center gap-3 rounded-lg px-4 py-3 text-sm font-medium shadow-md
//       ${verifying
//                 ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
//                 : verifyOk
//                   ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
//                   : "bg-red-50 text-red-700 border border-red-200"
//               }`}
//           >
//             {verifying && (
//               <>
//                 <ClockIcon className="h-5 w-5" />
//                 <span>Verifying payment…</span>
//               </>
//             )}

//             {verifyOk && (
//               <>
//                 <CheckCircleIcon className="h-5 w-5" />
//                 <span>
//                   Payment successful! 🎉 Show this confirmation at the venue entrance. Your seat awaits!
//                 </span>
//               </>
//             )}

//             {verifyErr && (
//               <>
//                 <XCircleIcon className="h-5 w-5" />
//                 <span>Payment failed: {verifyErr}</span>
//               </>
//             )}
//           </div>
//         </div>

//         {/* Body */}
//         <div className="px-6 md:px-8 pb-6 md:pb-8 mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
//           {/* Left: Details */}
//           <div className="md:col-span-2 space-y-6">
//             {/* Booking Details */}
//             <section className="rounded-xl border">
//               <div className="px-4 py-3 border-b">
//                 <div className="font-semibold text-slate-900">Booking Details</div>
//               </div>
//               <div className="px-4 py-3">
//                 <div className="grid grid-cols-4 text-sm font-semibold text-slate-500">
//                   <div>Order Amount</div>
//                   <div>Application Fee </div>
//                   <div>Gst</div>
//                   <div>Final Amount</div>
//                 </div>
//                 <div className="grid grid-cols-4 mt-2 text-slate-900 font-bold">
//                   <div>{fmtRs(ui.orderAmount)}</div>
//                   <div>{fmtRs(ui.fee)}</div>
//                   <div>{fmtRs(ui?.gst)}</div>
//                   <div>{fmtRs(ui.finalAmount)}</div>
//                 </div>
//               </div>
//             </section>

//             {/* Event Details */}
//             <section className="rounded-xl border">
//               <div className="px-4 py-3 border-b">
//                 <div className="font-semibold text-slate-900">Event Details</div>
//               </div>
//               <div className="px-4 py-3 text-sm text-slate-800 space-y-2">
//                 <Row label="Event:" value={ui.eventTitle} />
//                 <Row label="Venue:" value={ui.venue} />
//                 <Row label="Date & Time:" value={whenRange} />
//               </div>
//             </section>

//             {/* Attendee Info */}
//             <section className="rounded-xl border">
//               <div className="px-4 py-3 border-b">
//                 <div className="font-semibold text-slate-900">Attendee Info</div>
//               </div>
//               <div className="px-4 py-3 text-sm text-slate-800 space-y-2">
//                 <Row label="Name:" value={ui.attendeeName} />
//                 {ui.attendeePhone && <Row label="Mobile:" value={ui.attendeePhone} />}
//               </div>
//             </section>
//           </div>

//           {/* Right: Date card */}
//           <aside className="md:col-span-1">
//             <div className="rounded-2xl border shadow-sm px-5 py-6 text-center">
//               <div className="text-5xl leading-none font-extrabold text-[#4B1FA0]">
//                 {day}
//               </div>
//               <div className="mt-1 text-sm font-semibold tracking-wide text-[#4B1FA0]">
//                 {month}
//               </div>
//               <div className="mt-1 text-xs text-[#4B1FA0] opacity-80">
//                 {fullStamp}
//               </div>
//               <div className="mt-4 text-[11px] tracking-wide uppercase text-slate-500">
//                 #Booking ID
//               </div>
//               <div className="text-xl font-extrabold text-[#4B1FA0]">
//                 {ui.bookingId}
//               </div>

//               <button
//                 onClick={onPrint}
//                 className="mt-4 w-full rounded-full bg-[#4B1FA0] text-white font-semibold py-2 hover:opacity-95 print:hidden"
//               >
//                 PRINT BOOKING
//               </button>

//               {/* QR below print button (visible in print too) */}
//               {qrUrl && (
//                 <div className="mt-5 flex flex-col items-center">
//                   <img
//                     src={qrUrl}
//                     alt="Ticket QR Code"
//                     className="h-32 w-32 rounded bg-white p-1 border"
//                     crossOrigin="anonymous"
//                   />
//                   <div className="mt-1 text-[11px] text-slate-500">Scan at the gate</div>
//                 </div>
//               )}
//             </div>
//           </aside>

//         </div>
//       </div>

//       {/* Bottom: Download button (visible on screen, hidden in print) */}
//       <div className="pb-10 flex justify-center print:hidden">
//         <button
//           onClick={onDownload}
//           disabled={downloading}
//           className={`inline-flex items-center justify-center h-12 px-5 rounded-full border font-semibold ${downloading ? "bg-slate-200 text-slate-500 cursor-wait" : "bg-white hover:bg-slate-50"
//             }`}
//           title="Download Ticket (PDF)"
//         >
//           <DownloadCloudIcon className="h-5 w-5 mr-2 text-slate-700" />
//           {downloading ? "Generating…" : "Download Ticket"}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* helpers */
// function firstNum(pref, fallback) {
//   const n1 = Number(pref);
//   if (Number.isFinite(n1)) return n1;
//   const n2 = Number(fallback);
//   return Number.isFinite(n2) ? n2 : 0;
// }
// function fmtRs(x) {
//   const n = Number(x);
//   return Number.isFinite(n) ? `₹${n.toLocaleString("en-IN")}` : "—";
// }
// function Row({ label, value }) {
//   return (
//     <div className="flex items-start gap-2">
//       <div className="min-w-[130px] text-slate-500">{label}</div>
//       <div className="font-medium text-slate-900">{value}</div>
//     </div>
//   );
// }
// function DownloadCloudIcon({ className = "" }) {
//   return (
//     <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
//       <path d="M16 16l-4 4-4-4h3V9h2v7h3z" />
//       <path d="M20 16.5A4.5 4.5 0 0015.5 12h-.26A6.5 6.5 0 104 13.5" />
//     </svg>
//   );
// }




// src/pages/PaymentSuccessful.jsx – enhanced UI + subtle animations
// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useSearchParams } from "react-router-dom";
// import { format } from "date-fns";
// import { post } from "../lib/http.js";
// import { API } from "../config/api.js";
// import { CheckCircleIcon, XCircleIcon, ClockIcon, ArrowDownTrayIcon, PrinterIcon } from "@heroicons/react/24/solid";
// import { motion, AnimatePresence } from "framer-motion";

// function downloadBlob(blob, filenameFallback = "file.bin") {
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filenameFallback;
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
//   URL.revokeObjectURL(url);
// }

// function b64toBlob(b64, type) {
//   const bin = atob(b64);
//   const arr = new Uint8Array(bin.length);
//   for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
//   return new Blob([arr], { type });
// }

// export default function PaymentSuccessful() {
//   const { state } = useLocation();
//   const [search] = useSearchParams();
//   const ticketRef = useRef(null);

//   // read helper: state → query → default
//   const q = (k, d = "") => state?.[k] ?? search.get(k) ?? d;

//   // server verify state
//   const [verifying, setVerifying] = useState(true);
//   const [verifyOk, setVerifyOk] = useState(false);
//   const [verifyErr, setVerifyErr] = useState("");
//   const [server, setServer] = useState(null);
//   const [downloading, setDownloading] = useState(false);

//   // ---- POST to payout.PaymentSuccessful on mount ----
//   useEffect(() => {
//     const razorpay_payment_id = q("razorpay_payment_id");
//     const razorpay_payment_link_id = q("razorpay_payment_link_id");

//     if (!razorpay_payment_id || !razorpay_payment_link_id) {
//       setVerifying(false);
//       setVerifyOk(false);
//       setVerifyErr("Missing payment identifiers.");
//       return;
//     }

//     (async () => {
//       try {
//         setVerifying(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//         const res = await post(
//           API.payout.PaymentSuccessful,
//           { razorpay_payment_id, razorpay_payment_link_id },
//           {
//             headers: {
//               Authorization: token ? `Bearer ${token}` : undefined,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         setServer(res || null);
//         setVerifyOk(true);
//         setVerifyErr("");
//       } catch (err) {
//         console.error("PaymentSuccessful verify error:", err);
//         setVerifyOk(false);
//         setVerifyErr("Verification failed. Please contact support.");
//       } finally {
//         setVerifying(false);
//       }
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ---- Amount breakdown (GST-aware) ----
//   const gross = firstNum(server?.payment?.finalAmount, q("amount", "0")); // total paid (₹)
//   const gstPct = firstNum(server?.payment?.gstAmount, q("gst", "18")); // default 18%
//   const platformFee = firstNum(server?.fee, q("fee", "0")); // your fee (₹)

//   const baseExGST = Math.max(0, Math.round(server?.payment?.amount / (1 + gstPct / 100)) || 0);
//   const gstAmount = Math.max(0, (gross - platformFee) - baseExGST);

//   // ---- UI data (prefer server fields) ----
//   const ui = {
//     customerName: server?.booking?.userId?.name ?? q("name", "Guest"),
//     qrCodeUrl: server?.tickets?.qrCode,
//     orderAmount: server?.payment?.amount, // GST-excl base
//     fee: server?.payment?.convenienceFee,
//     gst: gstPct, // fee + GST
//     finalAmount: gross, // total paid

//     eventTitle: server?.booking?.eventId?.name ?? q("event", "Event"),
//     venue: server?.booking?.eventId?.venue?.name ?? q("venue", "Venue"),
//     startISO: server?.booking?.eventId?.date ?? q("start", ""),
//     endISO: server?.booking?.eventId?.date ?? q("end", ""),

//     bookingDateISO:
//       server?.bookedAt ?? server?.booking?.createdAt ?? q("date", new Date().toISOString()),
//     bookingId: server?.bookingId ?? server?.booking?.bookingCode ?? q("bookingId", "STMZ2025"),

//     attendeeName: server?.booking?.userId?.name ?? q("name", "Guest"),
//     attendeePhone: server?.booking?.userId?.mobile ?? q("phone", ""),
//   };

//   const day = format(new Date(ui.bookingDateISO), "dd");
//   const month = format(new Date(ui.bookingDateISO), "LLLL").toUpperCase();
//   const fullStamp = format(new Date(ui.bookingDateISO), "dd/MM/yyyy HH:mm:ss");

//   const whenRange =
//     ui.startISO && ui.endISO
//       ? `${format(new Date(ui.startISO), "MMM dd, yyyy")} - ${format(new Date(ui.endISO), "MMM dd, yyyy")}`
//       : ui.startISO
//       ? format(new Date(ui.startISO), "MMM dd, yyyy")
//       : "—";

//   const onPrint = () => window.print();

//   // ---- Direct PDF Download (no link needed) ----
//   const onDownload = async () => {
//     try {
//       setDownloading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user") || "{}")?.token ?? null;
//       const url = `http://20.41.122.214:5151/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
//         server?.booking?.bookingCode
//       )}`;

//       const resp = await fetch(url, {
//         method: "POST",
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       if (!resp.ok) {
//         const msg = await resp.text().catch(() => "");
//         throw new Error(`HTTP ${resp.status} ${msg}`);
//       }

//       const ct = (resp.headers.get("content-type") || "").toLowerCase();
//       let blob;

//       if (ct.includes("application/pdf")) {
//         blob = await resp.blob();
//       } else if (ct.includes("application/json")) {
//         const data = await resp.json().catch(() => ({}));
//         if (data?.pdfBase64) {
//           blob = b64toBlob(data.pdfBase64, "application/pdf");
//         } else if (data?.url) {
//           window.location.href = data.url;
//           return;
//         } else {
//           throw new Error("JSON received but no pdfBase64/url.");
//         }
//       } else {
//         blob = await resp.blob();
//       }

//       const cd = resp.headers.get("content-disposition") || "";
//       const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
//       const suggested = m && m[1] ? decodeURIComponent(m[1]) : undefined;

//       const safeEvent = (server?.booking?.eventId?.name || "ticket").replace(/\s+/g, "-").slice(0, 50);
//       const fallback = suggested || `${safeEvent}-${server?.booking?.bookingCode}.pdf`;

//       downloadBlob(blob, fallback);
//     } catch (err) {
//       console.error("PDF download error:", err);
//       alert(err?.message || "Could not download PDF. Please try again.");
//     } finally {
//       setDownloading(false);
//     }
//   };

//   const qrUrl = server?.tickets?.qrCode ?? q("qr", "");

//   return (
//     <div className="w-full px-4 md:px-6 py-8 print:py-0 flex justify-center">
//       {/* print CSS */}
//       <style>{`
//         @page { margin: 0; size: auto; }
//         @media print {
//           header, footer, nav, .site-header, .site-footer, .app-header, .app-footer { display: none !important; }
//           .print-wrap { box-shadow: none !important; border: 0 !important; border-radius: 0 !important; }
//           body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//         }
//         /* keyframes */
//         @keyframes floaty { 0%{transform:translateY(0)} 50%{transform:translateY(-6px)} 100%{transform:translateY(0)} }
//         @keyframes pulseGlow { 0%,100%{box-shadow:0 0 0 0 rgba(16,185,129,.5)} 50%{box-shadow:0 0 0 8px rgba(16,185,129,.12)} }
//         @keyframes shimmer { 0% { background-position: -468px 0 } 100% { background-position: 468px 0 } }
//       `}</style>

//       <div
//         ref={ticketRef}
//         className="print-wrap w-full max-w-5xl bg-white rounded-2xl shadow-md border relative overflow-hidden print:shadow-none print:border-0 print:rounded-none"
//       >
//         {/* Gradient ribbon */}
//         <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-fuchsia-500 via-violet-500 to-emerald-400" />

//         {/* Header */}
//         <div className="px-6 md:px-8 pt-8">
//           <div className="flex items-start md:items-center gap-3 md:gap-4">
//             <AnimatePresence initial={false}>
//               {verifying && (
//                 <motion.div
//                   key="verify"
//                   initial={{ scale: 0.8, opacity: 0 }}
//                   animate={{ scale: 1, opacity: 1 }}
//                   exit={{ opacity: 0, scale: 0.9 }}
//                   transition={{ type: "spring", stiffness: 260, damping: 20 }}
//                   className="p-2 rounded-full bg-yellow-100 text-yellow-700"
//                 >
//                   <ClockIcon className="h-7 w-7" />
//                 </motion.div>
//               )}
//               {!verifying && verifyOk && (
//                 <motion.div
//                   key="ok"
//                   initial={{ scale: 0 }}
//                   animate={{ scale: 1 }}
//                   transition={{ type: "spring", stiffness: 300, damping: 14 }}
//                   className="p-2 rounded-full bg-emerald-100 text-emerald-700"
//                   style={{ animation: "floaty 3s ease-in-out infinite" }}
//                 >
//                   <CheckCircleIcon className="h-7 w-7" />
//                 </motion.div>
//               )}
//               {!verifying && !verifyOk && (
//                 <motion.div
//                   key="err"
//                   initial={{ x: -8, opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   transition={{ type: "spring", stiffness: 300, damping: 18 }}
//                   className="p-2 rounded-full bg-red-100 text-red-700"
//                 >
//                   <XCircleIcon className="h-7 w-7" />
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             <div>
//               <h1 className="text-2xl md:text-3xl font-extrabold text-[#4B1FA0]">
//                 {verifyOk ? "Booking Confirmed!" : verifying ? "Processing payment" : "Payment Status"}
//               </h1>
//               <p className="mt-1 text-sm md:text-base text-[#4B1FA0]">
//                 {ui.customerName}, {verifyOk ? "your ticket is booked!" : verifying ? "please wait a moment…" : "see details below"}
//               </p>
//             </div>
//           </div>

//           {/* Notice bar */}
//           <motion.div
//             layout
//             className={`mt-5 flex items-center justify-center gap-3 rounded-xl px-4 py-3 text-sm font-medium shadow-sm border
//               ${verifying ? "bg-yellow-50 text-yellow-700 border-yellow-200" : verifyOk ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200"}
//             `}
//           >
//             <AnimatePresence mode="wait" initial={false}>
//               {verifying && (
//                 <motion.div key="nv" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex items-center gap-2">
//                   <ClockIcon className="h-5 w-5" />
//                   <span>Verifying payment…</span>
//                   <span className="ml-2 inline-block h-2 w-24 rounded-full bg-gradient-to-r from-yellow-200 via-white to-yellow-200 bg-[length:400px_100%] animate-[shimmer_1.3s_infinite]" />
//                 </motion.div>
//               )}
//               {!verifying && verifyOk && (
//                 <motion.div key="ok2" initial={{ y: 8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ opacity: 0, y: -8 }} className="flex items-center gap-2">
//                   <CheckCircleIcon className="h-5 w-5" />
//                   <span>Payment successful! 🎉 Show this confirmation at the venue entrance. Your seat awaits!</span>
//                 </motion.div>
//               )}
//               {!verifying && !verifyOk && (
//                 <motion.div key="er2" initial={{ y: 8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ opacity: 0, y: -8 }} className="flex items-center gap-2">
//                   <XCircleIcon className="h-5 w-5" />
//                   <span>Payment failed: {verifyErr}</span>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </motion.div>
//         </div>

//         {/* Body */}
//         <div className="px-6 md:px-8 pb-6 md:pb-10 mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
//           {/* Left: Details */}
//           <div className="md:col-span-2 space-y-6">
//             {/* Booking Details */}
//             <section className="rounded-2xl border overflow-hidden">
//               <div className="px-4 py-3 border-b bg-slate-50">
//                 <div className="font-semibold text-slate-900">Booking Details</div>
//               </div>
//               <div className="px-4 py-4">
//                 <div className="grid grid-cols-4 text-xs md:text-sm font-semibold text-slate-500">
//                   <div>Order Amount</div>
//                   <div>Application Fee</div>
//                   <div>GST</div>
//                   <div>Final Amount</div>
//                 </div>
//                 <motion.div layout className="grid grid-cols-4 mt-2 text-slate-900 font-bold">
//                   <div>{fmtRs(ui.orderAmount)}</div>
//                   <div>{fmtRs(ui.fee)}</div>
//                   <div>{fmtRs(gstAmount)}</div>
//                   <div className="text-emerald-700">{fmtRs(ui.finalAmount)}</div>
//                 </motion.div>
//               </div>
//             </section>

//             {/* Event Details */}
//             <section className="rounded-2xl border overflow-hidden">
//               <div className="px-4 py-3 border-b bg-slate-50">
//                 <div className="font-semibold text-slate-900">Event Details</div>
//               </div>
//               <div className="px-4 py-4 text-sm text-slate-800 space-y-2">
//                 <Row label="Event:" value={ui.eventTitle} />
//                 <Row label="Venue:" value={ui.venue} />
//                 <Row label="Date & Time:" value={whenRange} />
//               </div>
//             </section>

//             {/* Attendee Info */}
//             <section className="rounded-2xl border overflow-hidden">
//               <div className="px-4 py-3 border-b bg-slate-50">
//                 <div className="font-semibold text-slate-900">Attendee Info</div>
//               </div>
//               <div className="px-4 py-4 text-sm text-slate-800 space-y-2">
//                 <Row label="Name:" value={ui.attendeeName} />
//                 {ui.attendeePhone && <Row label="Mobile:" value={ui.attendeePhone} />}
//               </div>
//             </section>
//           </div>

//           {/* Right: Date card */}
//           <aside className="md:col-span-1">
//             <motion.div layout className="rounded-2xl border shadow-sm px-5 py-6 text-center">
//               <div className="text-5xl leading-none font-extrabold text-[#4B1FA0]">{day}</div>
//               <div className="mt-1 text-sm font-semibold tracking-wide text-[#4B1FA0]">{month}</div>
//               <div className="mt-1 text-xs text-[#4B1FA0] opacity-80">{fullStamp}</div>
//               <div className="mt-4 text-[11px] tracking-wide uppercase text-slate-500">#Booking ID</div>
//               <div className="text-xl font-extrabold text-[#4B1FA0]">{ui.bookingId}</div>

//               <div className="mt-5 grid grid-cols-2 gap-3 print:hidden">
//                 <button onClick={() => window.print()} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#4B1FA0] text-white font-semibold py-2 hover:opacity-95">
//                   <PrinterIcon className="h-5 w-5" />
//                   Print
//                 </button>
//                 <button onClick={onDownload} disabled={downloading} className={`inline-flex items-center justify-center gap-2 rounded-full border font-semibold py-2 ${downloading ? "bg-slate-200 text-slate-500 cursor-wait" : "bg-white hover:bg-slate-50"}`}>
//                   <ArrowDownTrayIcon className="h-5 w-5" />
//                   {downloading ? "Generating…" : "Download"}
//                 </button>
//               </div>

//               {qrUrl && (
//                 <div className="mt-5 flex flex-col items-center">
//                   <img src={qrUrl} alt="Ticket QR Code" className="h-32 w-32 rounded bg-white p-1 border" crossOrigin="anonymous" />
//                   <div className="mt-1 text-[11px] text-slate-500">Scan at the gate</div>
//                 </div>
//               )}
//             </motion.div>
//           </aside>
//         </div>

//         {/* Confetti sparkles on success */}
//         <AnimatePresence>
//           {verifyOk && !verifying && (
//             <motion.div
//               key="confetti"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               className="pointer-events-none absolute inset-0 overflow-hidden print:hidden"
//             >
//               <Sparkles />
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>
//     </div>
//   );
// }

// /* helpers */
// function firstNum(pref, fallback) {
//   const n1 = Number(pref);
//   if (Number.isFinite(n1)) return n1;
//   const n2 = Number(fallback);
//   return Number.isFinite(n2) ? n2 : 0;
// }
// function fmtRs(x) {
//   const n = Number(x);
//   return Number.isFinite(n) ? `₹${n.toLocaleString("en-IN")}` : "—";
// }
// function Row({ label, value }) {
//   return (
//     <div className="flex items-start gap-2">
//       <div className="min-w-[130px] text-slate-500">{label}</div>
//       <div className="font-medium text-slate-900">{value}</div>
//     </div>
//   );
// }

// // Tiny sparkles burst using pure divs (no external libs)
// function Sparkles() {
//   const items = Array.from({ length: 18 });
//   return (
//     <div className="absolute inset-0">
//       {items.map((_, i) => (
//         <motion.span
//           key={i}
//           initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
//           animate={{
//             opacity: [0, 1, 0],
//             scale: [0, 1, 0],
//             x: (Math.random() - 0.5) * 800,
//             y: (Math.random() - 0.5) * 500,
//             rotate: Math.random() * 360,
//           }}
//           transition={{ duration: 1.1 + Math.random() * 0.6, ease: "easeOut" }}
//           className="absolute left-1/2 top-16 h-2 w-2 rounded-full"
//           style={{ background:
//             ["#10B981","#34D399","#A78BFA","#8B5CF6","#FDE68A","#F472B6"][i % 6] }}
//         />
//       ))}
//     </div>
//   );
// }


// src/pages/PaymentSuccessful.jsx – premium UI + richer animations (v2)
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { post } from "../lib/http.js";
import { API } from "../config/api.js";
import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ArrowDownTrayIcon,
  PrinterIcon,
  QrCodeIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/solid";
import { motion, AnimatePresence } from "framer-motion";

/* ------------------ file helpers ------------------ */
function downloadBlob(blob, filenameFallback = "file.bin") {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameFallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
function b64toBlob(b64, type) {
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type });
}

/* ------------------ time helpers ------------------ */
// Toggle: true = trust server-local time inside ISO (use UTC parts -> no TZ shift)
// false = convert to IST (proper timezone conversion)
const USE_SERVER_LOCAL_TIME = true;

const fmtIST = (iso, options) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    ...options,
  }).format(d);
};

// Booking stamp: dd/MM/yyyy, HH:mm:ss IST
const fmtISTStamp = (iso) =>
  fmtIST(iso, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }) + " IST";

// UTC day label (server day): "15 Nov 2025"
const utcDayLabel = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const day = d.getUTCDate();
  return format(new Date(Date.UTC(y, m, day)), "dd MMM yyyy");
};

// Server-local time (use UTC parts so 20:00Z => "08:00 pm")
const serverLocalTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const hh = d.getUTCHours();
  const mm = d.getUTCMinutes();
  const h12 = ((hh + 11) % 12) + 1;
  const ampm = hh < 12 ? "am" : "pm";
  return `${String(h12).padStart(2, "0")}:${String(mm).padStart(2, "0")} ${ampm}`;
};

// Proper IST time (if you set USE_SERVER_LOCAL_TIME = false later)
const timeIST = (iso) =>
  fmtIST(iso, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

// Range label: "<UTC START day>, <start time> – <end time>"
// Time formatter depends on toggle
const fmtEventDateLabel = (startISO, endISO) => {
  if (!startISO && !endISO) return "—";
  const timeLabel = (iso) =>
    USE_SERVER_LOCAL_TIME ? serverLocalTime(iso) : timeIST(iso);

  if (startISO && !endISO)
    return `${utcDayLabel(startISO)}, ${timeLabel(startISO)}`;
  if (!startISO && endISO)
    return `${utcDayLabel(endISO)}, ${timeLabel(endISO)}`;

  // both present -> date from START (server day), times with chosen mode
  return `${utcDayLabel(startISO)}, ${timeLabel(startISO)} – ${timeLabel(endISO)}`;
};

const STB_PAYMENT_RETURN_KEY = "stb_payment_return_context";

export default function PaymentSuccessful() {
  const { state } = useLocation();
  const [search] = useSearchParams();
  const ticketRef = useRef(null);
  const purchaseSentRef = useRef(false);

  const q = (k, d = "") => state?.[k] ?? search.get(k) ?? d;

  // server verify state
  const [verifying, setVerifying] = useState(true);
  const [verifyOk, setVerifyOk] = useState(false);
  const [verifyErr, setVerifyErr] = useState("");
  const [server, setServer] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [copied, setCopied] = useState(false);

  // 🔵 Meta Pixel: fire Purchase once on success

  useEffect(() => {
    try {
      sessionStorage.removeItem(STB_PAYMENT_RETURN_KEY);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    const razorpay_payment_id = q("razorpay_payment_id");
    const razorpay_payment_link_id = q("razorpay_payment_link_id");

    // Accept EITHER param
    if (!razorpay_payment_id && !razorpay_payment_link_id) {
      setVerifying(false);
      setVerifyOk(false);
      setVerifyErr("Missing payment identifiers.");
      return;
    }

    (async () => {
      try {
        setVerifying(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await post(
          API.payout.PaymentSuccessful,
          { razorpay_payment_id, razorpay_payment_link_id },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : undefined,
              "Content-Type": "application/json",
            },
          }
        );
        setServer(res || null);
        setVerifyOk(true);
        setVerifyErr("");
      } catch (err) {
        console.error("PaymentSuccessful verify error:", err);
        setVerifyOk(false);
        setVerifyErr("Verification failed. Please contact support.");
      } finally {
        setVerifying(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ------------------ amount breakdown ------------------ */
  const gross = firstNum(server?.payment?.finalAmount, q("amount", "0"));
  const gstPct = firstNum(server?.payment?.gstAmount, q("gst", "18"));
  const platformFee = firstNum(server?.fee, q("fee", "0"));

  const baseExGST = Math.max(
    0,
    Math.round((server?.payment?.amount || 0) / (1 + gstPct / 100))
  );
  const gstAmount = firstNum(
    server?.payment?.gstAmount,
    q("gstAmount", String(gross - platformFee - baseExGST))
  );

  /* ------------------ UI data ------------------ */
  const evt = server?.booking?.eventId || {};
  const show0 = Array.isArray(evt?.showtimes) ? evt.showtimes[0] : null;

  const ui = {
    customerName: server?.booking?.userId?.name ?? q("name", "Guest"),
    qrCodeUrl: server?.tickets?.qrCode,
    orderAmount: server?.payment?.amount,
    fee: server?.payment?.convenienceFee,
    gst: gstPct,
    finalAmount: gross,

    eventTitle: evt?.name ?? q("event", "Event"),
    venue: evt?.venue?.name ?? q("venue", "Venue"),

    // Prefer explicit start/end -> showtimes -> fallback to evt.date / query
    startISO:
      evt?.startTime ??
      evt?.startDate ??
      show0?.startTime ??
      q("start", evt?.date || ""),
    endISO:
      evt?.endTime ??
      evt?.endDate ??
      show0?.endTime ??
      q("end", ""),

    bookingDateISO:
      server?.bookedAt ??
      server?.booking?.createdAt ??
      q("date", new Date().toISOString()),
    bookingId:
      server?.bookingId ??
      server?.booking?.bookingCode ??
      q("bookingId", "STMZ2025"),

    attendeeName: server?.booking?.userId?.name ?? q("name", "Guest"),
    attendeePhone: server?.booking?.userId?.mobile ?? q("phone", ""),
  };

  useEffect(() => {
  if (typeof window === "undefined" || !window.fbq) return;
  if (purchaseSentRef.current) return;           // avoid double fire
  if (verifying) return;                         // still verifying
  if (!verifyOk) return;                         // only on success

  // ⚠️ If your amounts are in paise, use: const valueInINR = Number(ui.finalAmount) / 100;
  const valueInINR = Number(ui.finalAmount) || 0;

  window.fbq("track", "Purchase", {
    value: valueInINR,
    currency: "INR",
    contents: [{ id: String(ui.bookingId || "NA") }],
    content_name: String(ui.eventTitle || "Event"),
    content_category: "Event Ticket",
    event_id: String(ui.bookingId || "NA"),
  });

  purchaseSentRef.current = true;
}, [verifying, verifyOk, ui.finalAmount, ui.bookingId, ui.eventTitle]);

  /* ------------------ Booking stamps in IST ------------------ */
  const day = fmtIST(ui.bookingDateISO, { day: "2-digit" }) || "—";
  const month =
    (
      new Intl.DateTimeFormat("en-US", {
        timeZone: "Asia/Kolkata",
        month: "long",
      }).format(new Date(ui.bookingDateISO)) || "—"
    ).toUpperCase();

  const fullStamp = fmtISTStamp(ui.bookingDateISO); // "dd/MM/yyyy, HH:mm:ss IST"

  /* ------------------ Event date/time line ------------------ */
  const whenRange = fmtEventDateLabel(ui.startISO, ui.endISO);

  /* ------------------ actions ------------------ */
  const onPrint = () => window.print();

  const onDownload = async () => {
    try {
      setDownloading(true);
      const newUrl = import.meta.env.VITE_API_BASE_URL;
      const token = JSON.parse(localStorage.getItem("bb_user") || "{}")?.token ?? null;

      const url = `${newUrl}/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
        server?.booking?.bookingCode
      )}`;

      const resp = await fetch(url, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (!resp.ok) {
        const msg = await resp.text().catch(() => "");
        throw new Error(`HTTP ${resp.status} ${msg}`);
      }

      const ct = (resp.headers.get("content-type") || "").toLowerCase();
      let blob;

      if (ct.includes("application/pdf")) {
        blob = await resp.blob();
      } else if (ct.includes("application/json")) {
        const data = await resp.json().catch(() => ({}));
        if (data?.pdfBase64) {
          blob = b64toBlob(data.pdfBase64, "application/pdf");
        } else if (data?.url) {
          window.location.href = data.url;
          return;
        } else {
          throw new Error("JSON received but no pdfBase64/url.");
        }
      } else {
        blob = await resp.blob();
      }

      const safeEvent = (server?.booking?.eventId?.name || "ticket")
        .trim()
        .replace(/ +/g, "-")
        .slice(0, 50);
      const fallback = `${safeEvent}-${server?.booking?.bookingCode}.pdf`;

      downloadBlob(blob, fallback);
    } catch (err) {
      console.error("PDF download error:", err);
      alert(err?.message || "Could not download PDF. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  const qrUrl = server?.tickets?.qrCode ?? q("qr", "");
  const hasTicket = Boolean(qrUrl);

  const copyBooking = async () => {
    try {
      await navigator.clipboard.writeText(String(ui.bookingId || ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {}
  };

  /* ------------------ UI ------------------ */
  return (
    <div className="min-h-[72vh] w-full bg-gradient-to-b from-violet-50/50 via-white to-slate-50 px-4 md:px-6 py-8 md:py-12 print:min-h-0 print:bg-white print:py-0 flex justify-center">
      <style>{`
        @page { margin: 0; size: auto; }
        @media print { header, footer, nav, .site-header, .site-footer, .app-header, .app-footer { display: none !important; } .print-wrap { box-shadow: none !important; border: 0 !important; border-radius: 0 !important; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        @keyframes floaty { 0%{transform:translateY(0)} 50%{transform:translateY(-6px)} 100%{transform:translateY(0)} }
        @keyframes shimmer { 0% { background-position: -468px 0 } 100% { background-position: 468px 0 } }
        @keyframes gradientShift { 0% { background-position: 0% 50% } 50% { background-position: 100% 50% } 100% { background-position: 0% 50% } }
        @keyframes ringPulse { 0% { box-shadow: 0 0 0 0 rgba(16,185,129,.45) } 70% { box-shadow: 0 0 0 12px rgba(16,185,129,0) } 100% { box-shadow: 0 0 0 0 rgba(16,185,129,0) } }
        .animate-gradient { background-size: 200% 200%; animation: gradientShift 7s ease infinite; }
        .skeleton { background: linear-gradient(90deg,#eee 25%,#f5f5f5 37%,#eee 63%); background-size: 400% 100%; animation: shimmer 1.3s infinite; }
      `}</style>

      <div
        ref={ticketRef}
        className="print-wrap w-full max-w-5xl bg-white rounded-2xl shadow-xl shadow-slate-200/80 border border-slate-200/90 ring-1 ring-slate-100 relative overflow-hidden print:shadow-none print:border-0 print:ring-0 print:rounded-none"
      >
        {/* Top animated gradient bar */}
        <div
          className={`absolute inset-x-0 top-0 h-2 ${
            verifyOk
              ? "animate-gradient bg-gradient-to-r from-emerald-400 via-violet-500 to-fuchsia-500"
              : verifying
              ? "bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-300 animate-gradient"
              : "bg-gradient-to-r from-rose-400 via-red-500 to-rose-400 animate-gradient"
          }`}
        />

        {/* Header */}
        <div className="px-5 sm:px-7 md:px-10 pt-8 md:pt-10">
          <div className="flex items-start md:items-center gap-3 md:gap-5">
            <AnimatePresence initial={false}>
              {verifying && (
                <motion.div
                  key="verify"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 260, damping: 20 }}
                  className="p-2 rounded-full bg-yellow-100 text-yellow-700"
                >
                  <ClockIcon className="h-7 w-7" />
                </motion.div>
              )}
              {!verifying && verifyOk && (
                <motion.div
                  key="ok"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 14 }}
                  className="p-2 rounded-full bg-emerald-100 text-emerald-700"
                  style={{
                    animation:
                      "floaty 3s ease-in-out infinite, ringPulse 2.6s infinite",
                  }}
                >
                  <CheckCircleIcon className="h-7 w-7" />
                </motion.div>
              )}
              {!verifying && !verifyOk && (
                <motion.div
                  key="err"
                  initial={{ x: -8, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 18 }}
                  className="p-2 rounded-full bg-red-100 text-red-700"
                >
                  <XCircleIcon className="h-7 w-7" />
                </motion.div>
              )}
            </AnimatePresence>

            <div className="min-w-0 flex-1">
              <h1 className="text-2xl sm:text-3xl md:text-[2rem] font-extrabold tracking-tight text-[#4B1FA0] leading-tight">
                {verifyOk
                  ? "Booking Confirmed!"
                  : verifying
                  ? "Processing payment"
                  : "Payment Status"}
              </h1>
              <p className="mt-2 text-sm md:text-base text-slate-600">
                <span className="font-semibold text-slate-800">{ui.customerName}</span>
                {verifyOk
                  ? " — your ticket is booked."
                  : verifying
                  ? " — please wait a moment…"
                  : " — see details below."}
              </p>
            </div>
          </div>

          {/* Animated status banner */}
          <motion.div
            layout
            aria-live="polite"
            className={`mt-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl px-4 py-3.5 sm:px-5 text-sm sm:text-[15px] font-medium leading-relaxed shadow-sm border ${
              verifying
                ? "bg-yellow-50 text-yellow-800 border-yellow-200/90"
                : verifyOk
                ? "bg-emerald-50/95 text-emerald-800 border-emerald-200/90"
                : "bg-red-50 text-red-800 border-red-200/90"
            }`}
          >
            <AnimatePresence mode="wait" initial={false}>
              {verifying && (
                <motion.div
                  key="nv"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="flex flex-wrap items-center gap-2"
                >
                  <ClockIcon className="h-5 w-5 shrink-0" />
                  <span>Verifying payment…</span>
                  <span className="inline-block h-2 w-24 rounded-full bg-gradient-to-r from-yellow-200 via-white to-yellow-200 bg-[length:400px_100%] animate-[shimmer_1.3s_infinite]" />
                </motion.div>
              )}
              {!verifying && verifyOk && (
                <motion.div
                  key="ok2"
                  initial={{ y: 8, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ opacity: 0, y: -8 }}
                  className="flex items-start gap-3 text-left"
                >
                  <CheckCircleIcon className="h-5 w-5 shrink-0 mt-0.5" />
                  <span className="max-w-3xl">
                    Payment successful. Show this confirmation at the venue entrance — your seat is reserved.
                  </span>
                </motion.div>
              )}
              {!verifying && !verifyOk && (
                <motion.div
                  key="er2"
                  initial={{ y: 8, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ opacity: 0, y: -8 }}
                  className="flex items-start gap-3 text-left"
                >
                  <XCircleIcon className="h-5 w-5 shrink-0 mt-0.5" />
                  <span>Payment failed: {verifyErr}</span>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* Progress stepper */}
          <div className="mt-5 flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-3 text-xs sm:text-[13px]">
            <Step active icon={<CheckCircleIcon className="h-4 w-4" />}>
              Payment Verified
            </Step>
            <Step active={verifyOk} icon={<PrinterIcon className="h-4 w-4" />}>
              Ticket Ready
            </Step>
            <Step
              active={verifyOk && hasTicket}
              icon={<QrCodeIcon className="h-4 w-4" />}
            >
              Ready to Scan
            </Step>
          </div>
        </div>

        {/* Body */}
        <div className="px-5 sm:px-7 md:px-10 pb-8 md:pb-12 mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          {/* Left: Details */}
          <div className="lg:col-span-7 space-y-5 md:space-y-6">
            {/* Booking Details */}
            <section className="rounded-2xl border border-slate-200/90 bg-white overflow-hidden shadow-sm">
              <div className="px-4 sm:px-5 py-3.5 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-violet-50/30">
                <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
                  Booking details
                </div>
                <div className="mt-0.5 text-sm font-semibold text-slate-900">
                  Amount breakdown
                </div>
              </div>
              <div className="px-4 sm:px-5 py-5">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                  {[
                    { k: "Order amount", v: fmtRs(ui.orderAmount) },
                    { k: "Convenience fee", v: fmtRs(ui.fee) },
                    { k: "GST", v: fmtRs(gstAmount) },
                    {
                      k: "You pay",
                      v: fmtRs(ui.finalAmount),
                      highlight: true,
                    },
                  ].map((row) => (
                    <div
                      key={row.k}
                      className={`rounded-xl border px-3 py-3 sm:py-3.5 min-h-[4.25rem] flex flex-col justify-center ${
                        row.highlight
                          ? "border-2 border-emerald-300/80 bg-emerald-50/80 shadow-sm shadow-emerald-900/5"
                          : "border-slate-100 bg-slate-50/40"
                      }`}
                    >
                      <div className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-slate-500 leading-tight">
                        {row.k}
                      </div>
                      {verifying ? (
                        <div className="mt-2 h-6 w-20 rounded skeleton" />
                      ) : (
                        <motion.div
                          layout
                          className={`mt-1.5 text-base sm:text-lg font-bold tabular-nums tracking-tight ${
                            row.highlight ? "text-emerald-800" : "text-slate-900"
                          }`}
                        >
                          {row.v}
                        </motion.div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Event Details */}
            <section className="rounded-2xl border border-slate-200/90 bg-white overflow-hidden shadow-sm">
              <div className="px-4 sm:px-5 py-3.5 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-violet-50/30">
                <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
                  Event details
                </div>
              </div>
              <div className="divide-y divide-slate-100 px-4 sm:px-5">
                {verifying ? (
                  <div className="py-4 space-y-3">
                    <div className="h-4 w-[70%] max-w-xs rounded skeleton" />
                    <div className="h-4 w-[55%] max-w-xs rounded skeleton" />
                    <div className="h-4 w-[85%] max-w-md rounded skeleton" />
                  </div>
                ) : (
                  <>
                    <Row label="Event" value={ui.eventTitle} />
                    <Row label="Venue" value={ui.venue} />
                    <Row label="Date & time" value={whenRange} />
                  </>
                )}
              </div>
            </section>

            {/* Attendee Info */}
            <section className="rounded-2xl border border-slate-200/90 bg-white overflow-hidden shadow-sm">
              <div className="px-4 sm:px-5 py-3.5 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-violet-50/30">
                <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
                  Attendee
                </div>
              </div>
              <div className="divide-y divide-slate-100 px-4 sm:px-5">
                {verifying ? (
                  <div className="py-4 space-y-3">
                    <div className="h-4 w-[50%] rounded skeleton" />
                    <div className="h-4 w-[40%] rounded skeleton" />
                  </div>
                ) : (
                  <>
                    <Row label="Name" value={ui.attendeeName} />
                    {ui.attendeePhone ? (
                      <Row label="Mobile" value={ui.attendeePhone} />
                    ) : null}
                  </>
                )}
              </div>
            </section>
          </div>

          {/* Right: Ticket / Date card */}
          <aside className="lg:col-span-5">
            <motion.div className="rounded-2xl border border-slate-200/90 bg-gradient-to-b from-white via-violet-50/20 to-slate-50/80 shadow-md px-5 sm:px-6 py-7 text-center relative overflow-hidden lg:sticky lg:top-6">
              <div
                className="pointer-events-none absolute inset-y-8 left-0 w-px border-l border-dashed border-slate-300/80 hidden sm:block"
                aria-hidden
              />
              {/* floating sticker on success */}
              {verifyOk && (
                <motion.div
                  initial={{ rotate: -6, y: -10, opacity: 0 }}
                  animate={{ rotate: -6, y: 0, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 180, damping: 18 }}
                  className="absolute right-2 top-4 sm:-right-1 sm:top-5 rotate-6 sm:rotate-12"
                >
                  <div className="px-4 py-1.5 rounded-lg text-[11px] sm:text-xs font-extrabold text-white bg-gradient-to-r from-emerald-500 to-emerald-600 shadow-md shadow-emerald-500/25">
                    PAID · {fmtRs(ui.finalAmount)}
                  </div>
                </motion.div>
              )}

              <div className="text-5xl sm:text-6xl leading-none font-extrabold text-[#4B1FA0] tabular-nums">
                {day}
              </div>
              <div className="mt-1.5 text-sm font-bold tracking-[0.2em] text-violet-700/90">
                {month}
              </div>
              <div className="mt-1 text-xs text-slate-500 font-medium">
                {fullStamp}
              </div>

              <div className="mt-6 text-[10px] sm:text-[11px] font-bold tracking-widest uppercase text-slate-400">
                Booking ID
              </div>
              <button
                type="button"
                onClick={copyBooking}
                title="Copy booking ID"
                className="mt-2 mx-auto w-full max-w-sm inline-flex items-center justify-center gap-2 rounded-xl border border-violet-200 bg-violet-50/80 px-3 py-2.5 text-[#4B1FA0] font-mono font-bold text-base sm:text-lg hover:bg-violet-100/90 transition-colors focus:outline-none focus:ring-2 focus:ring-violet-400/40"
              >
                <span className="truncate">{ui.bookingId}</span>
                <ClipboardDocumentIcon className="h-5 w-5 shrink-0 text-violet-600" />
              </button>
              <AnimatePresence>
                {copied && (
                  <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    className="mt-2 text-xs text-emerald-600 font-semibold"
                  >
                    Copied to clipboard
                  </motion.div>
                )}
              </AnimatePresence>

              <div className="mt-6 print:hidden space-y-2">
                <motion.button
                  type="button"
                  whileTap={{ scale: 0.98 }}
                  onClick={onDownload}
                  disabled={downloading}
                  className={`w-full inline-flex items-center justify-center gap-2 rounded-xl py-3 px-4 text-sm font-bold shadow-lg transition-all ${
                    downloading
                      ? "bg-slate-300 text-slate-600 cursor-wait shadow-none"
                      : "bg-[#4B1FA0] text-white shadow-violet-900/20 hover:brightness-110 active:brightness-95"
                  }`}
                >
                  <ArrowDownTrayIcon className="h-5 w-5 shrink-0" />
                  {downloading ? "Preparing PDF…" : "Download Ticket PDF"}
                </motion.button>
                <button
                  type="button"
                  onClick={onPrint}
                  className="w-full inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
                >
                  <PrinterIcon className="h-5 w-5 shrink-0" />
                  Print this page
                </button>
              </div>

              {qrUrl && (
                <motion.div
                  initial={{ rotateY: 180, opacity: 0 }}
                  animate={{ rotateY: 0, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 140, damping: 16 }}
                  className="mt-7 flex flex-col items-center [transform-style:preserve-3d]"
                >
                  <div className="rounded-2xl bg-white p-2 shadow-inner border border-slate-200/80">
                    <img
                      src={qrUrl}
                      alt="Ticket QR Code"
                      className="h-36 w-36 sm:h-40 sm:w-40 rounded-lg bg-white"
                      crossOrigin="anonymous"
                    />
                  </div>
                  <div className="mt-2 text-xs text-slate-500 font-medium">
                    Scan at the gate
                  </div>
                </motion.div>
              )}
            </motion.div>
          </aside>
        </div>

        {/* Confetti sparkles on success */}
        <AnimatePresence>
          {verifyOk && !verifying && (
            <motion.div
              key="confetti"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="pointer-events-none absolute inset-0 overflow-hidden print:hidden"
            >
              <Sparkles />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

/* ------------------ tiny helpers ------------------ */
function firstNum(pref, fallback) {
  const n1 = Number(pref);
  if (Number.isFinite(n1)) return n1;
  const n2 = Number(fallback);
  return Number.isFinite(n2) ? n2 : 0;
}
function fmtRs(x) {
  const n = Number(x);
  return Number.isFinite(n) ? `₹${n.toLocaleString("en-IN")}` : "—";
}
function Row({ label, value }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[minmax(0,7.5rem)_1fr] gap-x-4 gap-y-1 py-3.5 sm:items-baseline">
      <div className="text-xs font-bold uppercase tracking-wide text-slate-500 shrink-0">
        {label}
      </div>
      <div className="text-base sm:text-[1.05rem] font-semibold text-slate-900 leading-snug break-words">
        {value || "—"}
      </div>
    </div>
  );
}
function Step({ active = false, icon, children }) {
  return (
    <div
      className={`flex flex-1 min-w-0 items-center gap-2 rounded-xl px-3 py-2.5 border ${
        active
          ? "bg-emerald-50 border-emerald-200 text-emerald-700"
          : "bg-slate-50 border-slate-200 text-slate-500"
      }`}
    >
      <span
        className={`inline-flex items-center justify-center h-5 w-5 rounded-full ${
          active ? "bg-emerald-600 text-white" : "bg-slate-300 text-slate-700"
        }`}
      >
        {icon}
      </span>
      <span className="font-medium">{children}</span>
    </div>
  );
}

// Tiny sparkles burst using pure divs (no external libs)
function Sparkles() {
  const items = Array.from({ length: 22 });
  return (
    <div className="absolute inset-0">
      {items.map((_, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
          animate={{
            opacity: [0, 1, 0],
            scale: [0, 1, 0],
            x: (Math.random() - 0.5) * 800,
            y: (Math.random() - 0.5) * 500,
            rotate: Math.random() * 360,
          }}
          transition={{
            duration: 1.1 + Math.random() * 0.8,
            ease: "easeOut",
          }}
          className="absolute left-1/2 top-16 h-2 w-2 rounded-full"
          style={{
            background: [
              "#10B981",
              "#34D399",
              "#A78BFA",
              "#8B5CF6",
              "#FDE68A",
              "#F472B6",
            ][i % 6],
          }}
        />
      ))}
    </div>
  );
}
